module.exports = __webpack_public_path__ + "img/login-bg.5eb0bdbc.jpg";